export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/luke-chesser-aec6ab83229adb3ac2eeaf698a0df975.jpg";